import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import PageWrapper from "../../components/common/layout/PageWrapper";
import UniChecksEdit from "../../components/services/uniChecks/UniChecksEdit";

const UniChecksEditPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.edit`)}>
      <UniChecksEdit />
    </PageWrapper>
  );
};
export default UniChecksEditPage;
